// extracted by mini-css-extract-plugin
export var active = "_f7-2";
export var recordingDot = "_f7-1";
export var recordingIndicator = "_f7-0";